import DocumentSearchFilterReducer from "@us/Store/Data/DocumentSearchFilter/DocumentSearchFilterReducer";
import DocumentSearchPageReducer from "@us/Store/Data/DocumentSearchPage/DocumentSearchPageReducer";
import DocumentSearchReducer from "@us/Store/Reducer/DocumentSearchReducer";
import { combineReducers } from "redux";

const customDataReducerData = {
    documentSearch: DocumentSearchReducer,
    documentSearchFilter: DocumentSearchFilterReducer,
    documentSearchPage: DocumentSearchPageReducer
};

export type DataReducers = typeof customDataReducerData;

const customDataReducer = combineReducers(customDataReducerData as any);
export default customDataReducer;